import { ErrorHandler } from '@angular/core';

export class ConsoleErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    console.error(error);
  }
}
